import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { ExpandableSection } from '../../components/expandableSection';
import { ThemeRoomBackgroundControls } from '../../components/themes/themeRoomBackgroundControls';
import { ThemeTableColorControls } from '../../components/themes/themeTableColorControls';
import { useAppSelector } from '../../redux/store';
const PADDING_CSS = css `
  padding-top: 15px;
`;
export const SelfPanelThemeSubPanelContainer = () => {
    const isPokerScene = useAppSelector((state) => state.scene.roomSceneType === 'poker');
    if (!isPokerScene) {
        return null;
    }
    return (_jsxs(ExpandableSection, { expandableSectionType: 'self-theme', colorType: 'player-info', children: [_jsx(ThemeRoomBackgroundControls, { isSelfPanel: true }), _jsx("div", { css: PADDING_CSS, children: _jsx(ThemeTableColorControls, { isSelfPanel: true }) })] }));
};
